module.exports = __webpack_public_path__ + "img/2.fe29838b.jpg";